import { RecordDetailModal } from "./record-detail-modal";

interface DetailModalPropsI {
  open: boolean;
  onClose: () => void;
  onEdit?: () => void;
  data: Record<string, any> | null;
}

export const ClientDetailModal = ({
  open,
  onClose,
  onEdit,
  data,
}: DetailModalPropsI) => (
  <RecordDetailModal
    open={open}
    onClose={onClose}
    onEdit={onEdit}
    eyebrow="Cliente"
    title={data?.name}
    subtitle={data?.company}
    image={data?.logo}
    tags={[
      ...(data?.malimax === "Sí" ? [{ label: "Cliente Malimax" }] : []),
      ...(data?.statusClient ? [{ label: data.statusClient, muted: true }] : []),
    ]}
    sections={[
      {
        title: "Información general",
        fields: [
          { label: "Representante", value: data?.fullName },
          { label: "Identificación", value: data?.docNumber },
          { label: "Dirección", value: data?.address, full: true },
        ],
      },
      {
        title: "Empresa",
        fields: [
          { label: "Razón social", value: data?.company },
          { label: "RUC", value: data?.companyRuc },
          { label: "Dirección fiscal", value: data?.companyAddress, full: true },
        ],
      },
      {
        title: "Registro",
        fields: [
          { label: "Creado", value: data?.createdAt },
          { label: "Creado por", value: data?.userCreation },
          { label: "Última edición", value: data?.updatedAt },
          { label: "Editado por", value: data?.userEdition },
        ],
      },
    ]}
  />
);

export const UserDetailModal = ({
  open,
  onClose,
  onEdit,
  data,
}: DetailModalPropsI) => (
  <RecordDetailModal
    open={open}
    onClose={onClose}
    onEdit={onEdit}
    eyebrow="Usuario"
    title={data?.fullName}
    subtitle={data?.user ? `@${data.user}` : null}
    image={typeof data?.avatar === "string" ? data.avatar : null}
    tags={[
      ...(data?.profile ? [{ label: data.profile }] : []),
      ...(data?.type ? [{ label: data.type, muted: true }] : []),
    ]}
    sections={[
      {
        title: "Cuenta",
        fields: [
          { label: "Usuario", value: data?.user },
          { label: "Email", value: data?.mail },
          { label: "Teléfono", value: data?.phone },
          { label: "Perfil", value: data?.profile },
        ],
      },
      {
        title: "Organización",
        fields: [
          { label: "Cliente", value: data?.client },
          { label: "Tipo", value: data?.type },
          { label: "Área", value: data?.area },
          { label: "Cargo", value: data?.position },
        ],
      },
      {
        title: "Registro",
        fields: [
          { label: "Creado", value: data?.createdAt },
          { label: "Última edición", value: data?.updatedAt },
        ],
      },
    ]}
  />
);

export const ContactDetailModal = ({
  open,
  onClose,
  onEdit,
  data,
}: DetailModalPropsI) => (
  <RecordDetailModal
    open={open}
    onClose={onClose}
    onEdit={onEdit}
    eyebrow="Contacto de notificación"
    title={data?.name}
    subtitle={data?.mail}
    tags={data?.malimax === "Sí" ? [{ label: "Malimax" }] : []}
    sections={[
      {
        title: "Contacto",
        fields: [
          { label: "Email", value: data?.mail },
          { label: "Celular", value: data?.phone },
          { label: "Malimax", value: data?.malimax },
        ],
      },
      {
        title: "Registro",
        fields: [
          { label: "Creado", value: data?.createdAt },
          { label: "Creado por", value: data?.userCreation },
          { label: "Última edición", value: data?.updatedAt },
          { label: "Editado por", value: data?.userEdition },
        ],
      },
    ]}
  />
);
